import { Button } from 'react-bootstrap';
import React from 'react';
import { FundingData } from '../types';
import { openUrlInNewTab } from '../../util/window-utils';
import useAnalytics from '../../web-analytics/webAnalyticsContext';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';
import { useFundingConsultationLink } from '../hooks/useFundingConsultationLink';

export const FundingConsultationBanner = (props: { funding: FundingData | null | undefined }) => {
  const { funding } = props;
  const analytics = useAnalytics();

  const url = useFundingConsultationLink(funding);
  if (!funding || !url) return null;
  return (
    <div className="billing__banner">
      Not sure where to start? <br /> Book a free consultation with our funding experts to get
      personalized recommendations for your business.
      <Button
        variant="primary"
        className="funding__action-button button-apply"
        onClick={() => {
          openUrlInNewTab(url, {
            analytics,
            analyticsEvent: AnalyticsEvent.CONSULTATION_SCHEDULER_OPENED,
            properties: { source: 'funding-banner' },
          });
        }}
      >
        <span style={{ whiteSpace: 'nowrap' }}>Book a Consultation</span>
      </Button>
    </div>
  );
};
